export const statusProtestoList = [
    {value: 'RECUSADO', label: "Recusado"},
    {value: 'PROTESTADO', label: "Protestado"},
    {value: 'EM_ANDAMENTO', label: "Em andamento"},
    {value: 'NAO_EXECUTADO', label: "Não executado"},
]